module.exports = __webpack_public_path__ + "src/assets/models/molar/molar_scene_planes.fbx";